import { Colors, regExp } from '@sigma-frontend-libs/commons'

import { components, icons, popperPlacements } from '@/utils'

import info from '@/components/info'
import { serviceNameKebabCase, serviceNameViaPoint } from '@/components/services/url-shortener-settings/presets/utils'
import sticker from '@/components/sticker'
import validationInfo from '@/components/validationInfo'

function renderCharSetsActivator(h) {
  let charSetsColor
  if (this.charactersFilled) {
    charSetsColor = Colors.success
  } else {
    charSetsColor = Colors.error
  }

  return h(
    sticker,
    {
      props: {
        value: this.charSetsLabel,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.characters`),
        icon: icons.abc,
        color: charSetsColor,
        onClick: () => {
          return null
        },
        button: this.charSetsStickerButton,
        width: '100%'
      },
      slot: 'activator'
    }
  )
}
function renderCharSetsSwitch(h, type) {
  return h(
    components.switch,
    {
      props: {
        value: this.charSets[type],
        outline: true,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.charSets.${type}`)
      },
      on: {
        input: event => {
          this.updateCharset(type, event)
        }
      }
    }
  )
}
function renderCharSetsSwitches(h) {
  return Object.keys(this.charSets).map(type => {
    return renderCharSetsSwitch.call(this, h, type)
  })
}
function renderCharsetContent(h) {
  return h(
    'div',
    {
      class: `${serviceNameKebabCase}-form__card`
    },
    [ renderCharSetsSwitches.call(this, h) ]
  )
}
function renderCharSetsMenu(h) {
  return h(
    components.menu,
    {
      props: {
        closeOnContentClick: false,
        offsetDistance: 8,
        placement: popperPlacements['bottom-start'],
        sameWidth: true,
        rounded: true
      }
    },
    [
      renderCharSetsActivator.call(this, h),
      renderCharsetContent.call(this, h)
    ]
  )
}

function renderParamsActivator(h) {
  return h(
    sticker,
    {
      props: {
        value: this.$_label,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.generationParams.title`),
        color: this.$_color,
        icon: icons.settings,
        onClick: () => {
          return null
        },
        button: this.paramsStickerButton,
        width: '100%'
      },
      slot: 'activator'
    }
  )
}
function renderParamsLengthField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.generationParams.length,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.generationParams.length`),
        dense: true,
        details: false,
        clearable: true,
        mask: regExp.digits
      },
      on: {
        input: event => {
          this.proxy.generationParams.length = event
        }
      }
    }
  )
}
function renderParamsPatternField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.generationParams.pattern,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.generationParams.pattern`),
        hint: this.getTranslate(`${serviceNameViaPoint}.hints.generationParams.pattern`),
        dense: true,
        details: true,
        clearable: true
      },
      on: {
        input: event => {
          this.proxy.generationParams.pattern = event
        }
      }
    }
  )
}
function renderAllFieldsFilledError(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${serviceNameViaPoint}.errors.generationParams.allFieldsFilled`),
        color: Colors.error
      }
    }
  )
}
function renderParamsValidationInfo(h) {
  return h(
    validationInfo,
    {
      props: {
        value: this.validationGroups,
        highlightInvalid: true
      }
    },
    [ renderAllFieldsFilledError.call(this, h) ]
  )
}
function renderParamsContent(h) {
  return h(
    'div',
    {
      class: `${serviceNameKebabCase}-form__card ${serviceNameKebabCase}-form__card--other`
    },
    [
      renderParamsLengthField.call(this, h),
      renderParamsPatternField.call(this, h),
      renderParamsValidationInfo.call(this, h)
    ]
  )
}

function renderParamsMenu(h) {
  return h(
    components.menu,
    {
      props: {
        closeOnContentClick: false,
        offsetDistance: 8,
        placement: popperPlacements['bottom-start'],
        sameWidth: true,
        rounded: true
      }
    },
    [
      renderParamsActivator.call(this, h),
      renderParamsContent.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8'
    },
    [
      renderCharSetsMenu.call(this, h),
      renderParamsMenu.call(this, h)
    ]
  )
}
